export default {
  props: {
    detailsInfo: {
      type: Object,
      required: true,
    },

    headerTitle: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    fields: [],
  }),

  methods: {
    createFields() {
      Object.entries(this.detailsInfo).forEach(([key, value]) => {
        const [valueField, typeField] = this.getValue(value);
        const data = {
          value: valueField,
          attribute: key,
          label: this.getLabel(key),
          type: typeField,
        };
        this.fields.push(data);
      });
    },

    getLabel(label) {
      const labelText = label[0].toUpperCase() + label.substring(1);
      return labelText.replace(/([a-z])([A-Z])/g, '$1 $2');
    },

    getValue(dataValue) {
      const valueField = [];
      if (typeof dataValue !== 'object') {
        return [dataValue, 'string'];
      }

      if (Array.isArray(dataValue)) {
        let isArrayOfObjects = false;
        for (let arrayItem = 0; arrayItem < dataValue.length; arrayItem += 1) {
          if (typeof dataValue[arrayItem] === 'object') {
            isArrayOfObjects = true;
            Object.entries(dataValue[arrayItem]).forEach(([key, value]) => {
              const [fieldValue, fieldType] = this.getValue(value);
              const valueData = {
                value: fieldValue,
                attribute: key,
                label: this.getLabel(key),
                type: fieldType,
              };
              valueField.push(valueData);
            });
          }
        }

        if (isArrayOfObjects) {
          return [valueField, 'object'];
        }

        return [dataValue, 'array'];
      }
      Object.entries(dataValue).forEach(([key, value]) => {
        const [fieldValue, fieldType] = this.getValue(value);
        if (fieldValue) {
          const valueData = {
            value: fieldValue,
            attribute: key,
            label: this.getLabel(key),
            type: fieldType,
          };
          valueField.push(valueData);
        }
      });

      return [valueField, 'object'];
    },
  },
};
